import TableBooleanAll from '../../components/Table/TableBoolean/TableBooleanAll';

const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'Zipcode',
        text: 'Zip Code',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'InternalId',
        text: 'Instance',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'TerritoryTypeId',
        text: 'Type',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => {
            switch (row.TerritoryTypeId) {
                case 1: return "Franchise";
                case 2: return "Marketing";
                case 3: return "ROFR";
            }
        }
    },
    {
        dataField: 'BranchOffice',
        text: 'Branch Office',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'Deleted',
        text: 'Status',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => {
            return <TableBooleanAll value={row.Active === true} text={row.Active === true ? 'Active' : 'Inactive'} />
        }
    },
];

export const sorting = [{
    dataField: 'Zipcode',
    order: 'desc'
}];